<template>
  <el-drawer
      title="产品选择"
      :visible.sync="visible"
      size="50%"
      :before-close="handleClose"
      :wrapperClosable="false"
      class="product-select-drawer"
  >
    <div class="drawer-container">
      <!-- 顶部操作栏 -->
      <div class="top-bar">
        <product-select-host
            v-model:keyword="keyword"
            @search="handleSearch"
            placeholder="请输入产品名称"
        >
          <template #search-button="{ performSearch }">
            <el-button type="primary" v-perm="'addProduct'" @click="performSearch">
              搜索
            </el-button>
          </template>
        </product-select-host>
<!--        <el-input-->
<!--            v-model="keyword"-->
<!--            placeholder="请输入产品名称"-->
<!--            clearable-->

<!--            @keyup.enter.native="handleSearch"-->
<!--            class="search-input"-->

<!--        >-->
<!--          -->
<!--          <el-button-->
<!--              slot="append"-->
<!--              icon="el-icon-search"-->
<!--              @click="handleSearch"-->
<!--              type="primary"-->
<!--              class="search-btn"-->
<!--          ></el-button>-->
<!--        </el-input>-->

        <div class="action-buttons">
          <el-button
              v-if="showReturnButton"
              type="text"
              icon="el-icon-refresh-left"
              @click="handleReturn"
              class="return-btn"
          >
            返回
          </el-button>
          <el-button
              type="primary"
              :disabled="selectedProducts.length === 0"
              @click="uploadSelectedProducts"
              icon="el-icon-upload"
              class="upload-btn"
          >
            上传订单({{ selectedProducts.length }})
          </el-button>
          <el-button
              @click="showSelectedDrawer = true"
              icon="el-icon-shopping-cart"
              :class="{ 'has-selected': selectedProducts.length > 0 }"
              class="selected-btn"
          >
            查看已选
          </el-button>
        </div>
      </div>


      <!-- 产品表格 -->
      <div class="table-container">
        <el-table
            :data="productLists"
            v-loading="productLoading"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.7)"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            @select="handleRowSelect"
            @select-all="handleSelectAll"
            :row-key="getRowKey"
            ref="productTable"
            height="calc(100%)"
            class="custom-table"
        >
          <el-table-column type="selection" width="48" align="center"  :reserve-selection="true"/>
          <el-table-column
              prop="productName"
              label="产品名称"
              min-width="100"
              align="center"
          >
            <template slot-scope="{ row }">
              <span class="product-name">{{ row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品图片" width="110" align="center">
            <template slot-scope="{ row }">
              <el-image
                  :src="row.picture"
                  style="width: 80px; height: 80px; border-radius: 4px"
                  fit="cover"
                  :preview-src-list="[row.picture]"
              />
            </template>
          </el-table-column>
          <el-table-column
              prop="productClassify.productClassifyName"
              label="分类"
              width="120"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag size="small" effect="plain">
                {{ getClassifyName(row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="productClassify.productClassifyName"
              label="规格"
              width="120"
              align="center"
          >
            <template slot-scope="{ row }">
              <span class="product-name">{{ row.spec }}</span>
            </template>

          </el-table-column>
          <el-table-column
              prop="productStock.stock"
              label="库存"
              width="96"
              align="center"
          >
            <template slot-scope="{ row }">
              <el-tag :type="getStockTagType(row)" size="small" effect="plain">
                {{ getStockCount(row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格" width="120" align="center">
            <template slot-scope="{ row }">
              <span class="price">¥{{ getFormattedPrice(row) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="totals"
            layout="total, prev, pager, next, jumper"
            :pager-count="5"
            small
            background
        />
      </div>

      <!-- 已选产品抽屉 -->
      <el-drawer
          title="已选产品"
          :visible.sync="showSelectedDrawer"
          size="30%"
          direction="rtl"
          :append-to-body="true"
          class="selected-drawer"
      >
        <div class="selected-drawer-content">
          <div v-if="selectedProducts.length > 0" class="selected-inner">
            <div class="selected-header">
              <div class="selected-count">
                <i class="el-icon-shopping-cart"></i>
                <span>已选 {{ selectedProducts.length }} 件商品</span>
              </div>
              <el-button
                  type="text"
                  @click="clearAllSelected"
                  class="clear-all-btn"
              >
                <i class="el-icon-delete"></i> 删除所有
              </el-button>
            </div>

            <el-scrollbar class="selected-scrollbar">
              <div class="selected-list">
                <div
                    class="selected-item"
                    v-for="item in selectedProducts"
                    :key="item.id"
                >
                  <div class="item-image">
                    <el-image
                        :src="item.picture"
                        style="width: 60px; height: 60px"
                        fit="cover"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="item-info">
                    <div class="item-name">{{ item.productName }}</div>
                    <div class="item-meta">
                      <span class="item-price">¥{{ getFormattedPrice(item) }}</span>
                      <span class="item-stock">库存: {{ getStockCount(item) }}</span>
                    </div>
                  </div>
                  <div class="item-actions">
                    <el-button
                        type="text"
                        size="mini"
                        @click.stop="removeSelected(item.id)"
                        class="remove-btn"
                    >
                      <i class="el-icon-circle-close"></i>
                    </el-button>
                  </div>

                </div>
              </div>
            </el-scrollbar>

            <div class="selected-footer">
              <el-button
                  type="primary"
                  size="medium"
                  @click="uploadSelectedProducts"
                  class="confirm-btn"
                  :disabled="selectedProducts.length === 0"
              >
                <i class="el-icon-upload"></i> 确认选择 ({{ selectedProducts.length }})
              </el-button>
            </div>
          </div>

          <div v-else class="empty-selected">
            <el-empty description="暂无已选产品"></el-empty>
            <el-button
                type="text"
                size="small"
                @click="showSelectedDrawer = false"
                class="back-btn"
            >
              <i class="el-icon-arrow-left"></i> 返回选择
            </el-button>
          </div>
        </div>
      </el-drawer>
    </div>
  </el-drawer>
</template>

<script>
import productSelectHost from "../productMag/productSelectHost.vue";

export default {
  name: 'ProductSelect',
  components: {productSelectHost},
  props: {
    visible: Boolean,
    selectedProductsFromParent: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      silentUpdating: false,
      keyword: '',
      currentPage: 1,
      pageSize: 20,
      totals: 0,
      productLists: [],
      productLoading: false,
      selectedProducts: [], // 改为数组存储已选产品
      showSelectedDrawer: false,

      prevState: {
        keyword: '',
        currentPage: 1,
        productLists: [],
        totals: 0
      },
      showReturnButton: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedProducts = [...this.selectedProductsFromParent];
        this.currentPage = 1;
        this.getproductLists().then(() => {
          this.updateTableSelection(); // ✅ 等加载完再回显
        });
      } else {
        this.resetState();
      }
    },
    selectedProductsFromParent: {
      deep: true,
      handler(newVal) {
        this.selectedProducts = [...newVal];
        this.updateTableSelection(); // ✅ 父组件更新时，同步回显
      }
    }
  },

  methods: {
    handleRowSelect(selection, row) {
      this.handleSelectionChange(selection, row);
    },

    handleSelectAll(selection) {
      // select-all 没有 changedRow，直接设为 null
      this.handleSelectionChange(selection, null);
    },

    // 每页加载后，刷新表格勾选状态
    updateTableSelection() {
      this.silentUpdating = true; // 👈 标记为静默更新
      this.$nextTick(() => {
        const table = this.$refs.productTable;
        if (!table) return;

        table.clearSelection(); // ⚠️ 会触发 selection-change

        this.productLists.forEach(row => {
          const found = this.selectedProducts.find(p => p.id === row.id);
          if (found) {
            table.toggleRowSelection(row, true); // 会再次触发 selection-change
          }
        });

        // 延时清除标志（确保本轮 DOM patch 完成）
        setTimeout(() => {
          this.silentUpdating = false;
        }, 0);
      });
    },

    // 每页数据变化时触发
    handleSelectionChange(selection, changedRow) {
      if (this.silentUpdating) {
        return; // 👈 不处理自动触发的更新
      }
      const currentPageIds = this.productLists.map(p => p.id);
      const selectedIds = this.selectedProducts.map(p => p.id);

      if (changedRow) {
        // ✅ 单条选中
        if (selection.includes(changedRow) && !selectedIds.includes(changedRow.id)) {
          this.selectedProducts.push(changedRow);
        }

        // ✅ 单条取消
        if (!selection.includes(changedRow)) {
          const index = this.selectedProducts.findIndex(p => p.id === changedRow.id);
          if (index > -1) {
            this.selectedProducts.splice(index, 1);
          }
        }
      } else {
        if (selection.length === 0) {
          this.selectedProducts = this.selectedProducts.filter(p => !currentPageIds.includes(p.id));
        } else {
          // 全选操作：加回所有当前页选中的
          const newSelected = selection.filter(row => !selectedIds.includes(row.id));
          this.selectedProducts.push(...newSelected);
        }
      }

    },

    // 选项被移除时同步勾选框状态
    removeSelected(id) {
      this.selectedProducts = this.selectedProducts.filter(p => p.id !== id);
      this.$nextTick(() => {
        const row = this.productLists.find(item => item.id === id);
        if (row && this.$refs.productTable) {
          this.$refs.productTable.toggleRowSelection(row, false);
        }
      });
    },

    // 清空所有已选项
    clearAllSelected() {
      this.$confirm('确定要清空所有已选产品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedProducts = [];
        this.updateTableSelection();
      }).catch(() => {
        this.$message.info('已取消清空操作');
      });
    },

    // 页面切换时加载数据并同步选中状态
    handlePageChange(page) {
      this.currentPage = page;
      this.getproductLists().then(() => {
        this.updateTableSelection();  // 👈关键：回显
      });
    },

    // 搜索后页码重置 & 勾选刷新
    handleSearch(searchKeyword) {
      this.keyword = searchKeyword;

      this.saveCurrentState();
      this.showReturnButton = true;
      const logininfo = JSON.parse(localStorage.getItem("logininfo"));
      this.loginid = logininfo.id;
      this.searchId=this.$searchUtils.generateSearchId();
      this.currentPage = 1;
      this.getproductLists().then(() => {
        this.updateTableSelection(); // 👈关键：回显
      });
    },

    // 上传操作从 selectedProducts 中读取
    uploadSelectedProducts() {
      this.$emit('upload-products', this.selectedProducts);
      this.$emit('update:visible', false);
    },

    resetState() {
      this.keyword = '';
      this.currentPage = 1;
      this.productLists = [];
      this.selectedProducts = [];
      this.totals = 0;
      this.showSelectedDrawer = false;
      this.productLoading = false;
      this.showReturnButton = false;
      this.prevState = {
        keyword: '',
        currentPage: 1,
        productLists: [],
        totals: 0
      };
    },

    getRowKey(row) {
      return row.id;
    },

    getClassifyName(row) {
      return (row.productClassify && row.productClassify.productClassifyName) || '未分类';
    },

    getStockCount(row) {
      return (row.productStock && row.productStock.stock) || 0;
    },

    getFormattedPrice(row) {
      return (row.price && row.price.toFixed(2)) || '0.00';
    },

    getStockTagType(row) {
      const stock = this.getStockCount(row);
      if (stock > 50) return 'success';
      if (stock > 10) return 'warning';
      return 'danger';
    },

    saveCurrentState() {
      this.prevState = {
        keyword: this.keyword,
        currentPage: this.currentPage,
        productLists: [...this.productLists],
        totals: this.totals
      };
    },


    handleReturn() {
      if (!this.prevState.keyword) return;

      this.keyword = '';
      this.currentPage = this.prevState.currentPage;
      this.productLists = [...this.prevState.productLists];
      this.totals = this.prevState.totals;
      this.showReturnButton = false;
      this.updateTableSelection();
    },

    handleSearchClear() {
      if (this.keyword && this.prevState.keyword) {
        this.handleReturn();
      } else {
        this.keyword = '';
        this.currentPage = 1;
        this.getproductLists().then(() => {
          this.updateTableSelection();
        });
      }
    },

    getproductLists() {
      this.productLoading = true;
      const para = {
        loginid:this.loginid,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        searchId:this.searchId,
        keyWords: this.keyword
            ? this.keyword.split(',').map(name => name.trim()).filter(name => name)
            : []
      };
      return this.$http.post('/productList/forSale', para)
          .then(res => {
            this.productLists = res.data.records.map(p => ({
              ...p,
              label: p.label ? p.label.split(' ') : []
            }));
            this.totals = res.data.total;
          })
          .catch(() => {
            this.$message.error('加载失败，请稍后重试');
          })
          .finally(() => {
            this.productLoading = false;
            if(this.searchId){
              this.searchId='';
            }
          });
    },

    handleClose(done) {
      this.resetState();
      this.$emit('update:visible', false);
      done();
    }

  }

};
</script>


<style lang="scss" scoped>
.product-select-drawer {
  .el-drawer__header {
    margin: 0;
    padding: 16px;
    border-bottom: 1px solid #e8e8e8;

    span {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
  }

  .el-drawer__body {
    padding: 0;
    height: 100%;
  }
}

.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.top-bar .search-input {
  width: 280px;
  margin-right: 16px;
  transition: box-shadow 0.3s ease;
}

.top-bar .search-input input {
  border-radius: 4px;
}

.top-bar .search-input input:focus {
  box-shadow: 0 0 6px rgba(64, 158, 255, 0.4);
  border-color: #409EFF;
}

.top-bar .action-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.top-bar .action-buttons .el-button[type="text"] {
  color: #409EFF;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.top-bar .action-buttons .el-button[type="text"]:hover {
  background-color: #ecf5ff;
}

.top-bar .action-buttons .el-button[type="primary"] {
  border-radius: 4px;
  padding: 6px 18px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  transition: box-shadow 0.3s ease;
}

.top-bar .action-buttons .el-button[type="primary"]:hover {
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.5);
}

.top-bar .action-buttons .has-selected {
  color: #67C23A;
  font-weight: 600;
  transition: color 0.3s ease;
}

.top-bar .action-buttons .has-selected:hover {
  color: #409EFF;
}


.table-container {
  flex: 1;
  padding: 0 16px;
  overflow: hidden;

  .custom-table {
    border: none;

    &::before {
      display: none;
    }

    .el-table__header th {
      background-color: #f8f8f8;
      color: #666;
      font-weight: 500;
    }

    .el-table__row:hover {
      background-color: #f5f7fa;
    }

    .product-name {
      font-weight: 500;
      color: #333;
    }

    .price {
      font-weight: 500;
      color: #f56c6c;
    }
  }
}

.pagination-container {
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  text-align: right;
}

.has-selected {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    right: 2px;
    width: 6px;
    height: 6px;
    background-color: #f56c6c;
    border-radius: 50%;
  }
}

/* 已选产品抽屉样式 */
.selected-drawer {
  .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.selected-drawer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.selected-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.selected-header {
  padding: 16px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f7fa;
}

.selected-count {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;

  i {
    margin-right: 8px;
    color: #409eff;
    font-size: 18px;
  }
}

.clear-all-btn {
  color: #f56c6c;
  padding: 5px;

  i {
    margin-right: 4px;
  }
}

/* 滚动内容区域 */
.selected-scrollbar {
  flex: 1;
}
.selected-drawer-content {
  padding-right: 2px; /* 防止滚动条太靠右 */
}
.selected-list {
  padding: 10px 10px;
}

.selected-item {
  position: relative; // 添加
  display: flex;
  align-items: center;
  padding: 12px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  margin-right: 5px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);

    .remove-btn {
      opacity: 1;
      pointer-events: auto;
    }
  }
}

.item-actions {
  position: absolute;
  top: 8px;
  right: 8px;
}

.remove-btn {
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease;
  padding: 4px;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 23px;
    color: #3a8ee6;
  }

  &:hover {
    background-color: rgba(255, 102, 102, 0.15); // 浅红背景
    i {
      color: #F56C6C;
    }
  }
}



.selected-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);
}

.item-image {
  width: 60px;
  height: 60px;
  margin-right: 12px;
  flex-shrink: 0;
}

.item-image .el-image {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: #f5f7fa;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #c0c4cc;
}

.image-slot i {
  font-size: 24px;
}

.item-info {
  flex: 1;
  min-width: 0;
}

.item-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.item-price {
  color: #f56c6c;
  font-weight: 600;
}

.item-stock {
  color: #909399;
}
.remove-btn:hover {
  color: #f56c6c;
}

.selected-footer {
  padding: 16px;
  border-top: 1px solid #ebeef5;
  text-align: center;
  background: #fff;
  flex-shrink: 0;
}

.confirm-btn {
  width: 90%;
  border-radius: 20px;
  font-weight: 500;
}

.confirm-btn i {
  margin-right: 6px;
}

.empty-selected {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
}

.back-btn {
  margin-top: 20px;
  color: #409eff;
}

.back-btn i {
  margin-right: 4px;
}
</style>




// WEBPACK FOOTER //
// productSelect.vue?757a191b